import { DirectUpload } from '@rails/activestorage'

const stripBearer = (sessionToken) => {
  if (sessionToken === undefined) { return undefined }
  if (sessionToken.includes('Bearer')) { return sessionToken.split(/[ +]/)[1] }
  return sessionToken
}

export default class DirectUploader {
  constructor (uploader = DirectUpload, sessionToken = undefined, delegate = undefined) {
    this.api_url = '/rails/active_storage/direct_uploads'
    this.Uploader = uploader
    this.sessionToken = stripBearer(sessionToken)
    this.delegate = delegate
  }

  setSessionToken (sessionToken) {
    if (sessionToken === undefined) { return }

    this.sessionToken = stripBearer(sessionToken)
  }

  getApiUrl () {
    if (this.sessionToken === undefined) {
      console.warn('SessionToken is not set!')
    }
    return `${this.api_url}`
  }

  authorizationHeader () {
    if (this.sessionToken === undefined) { return undefined }

    return `Bearer ${this.sessionToken}`
  }

  directUploadWillCreateBlobWithXHR (request) {
    const header = this.authorizationHeader()
    if (header === undefined) { return }

    request.setRequestHeader('Authorization', header)
  }

  uploadFile (file, field) {
    const upload = new this.Uploader(file, this.getApiUrl(), this)

    return new Promise((resolve, reject) => {
      upload.create((error, blob) => {
        if (error) {
          // TODO: Log this to appsignal and resolve
          console.log(error)
          reject(error)
        } else {
          resolve([blob, field])
        }
      })
    })
  }

  directUploadWillStoreFileWithXHR (request) {
    if (this.delegate != null) {
      request.upload.addEventListener('progress',
        event => this.delegate.handleProcessChange(event))
    }
  }
}
